import { AUTHORITY_TYPES, FIELD_AUTHORITY_MAPPING } from './authorityTypes';

// Validation rules based on existing field mappings
export const AUTHORITY_VALIDATION_RULES = {
  'contributors.name': {
    allowedAuthorityTypes: [
      AUTHORITY_TYPES.PERSONAL_NAME,
      AUTHORITY_TYPES.CORPORATE_NAME,
      AUTHORITY_TYPES.MEETING_NAME,
    ],
    requiresContributorType: true,
  },
  'subjects.value': {
    allowedAuthorityTypes: [AUTHORITY_TYPES.SUBJECT],
    requiresContributorType: false,
  },
  'series.value': {
    allowedAuthorityTypes: [AUTHORITY_TYPES.UNIFORM_TITLE],
    requiresContributorType: false,
  },
  'alternativeTitles.alternativeTitle': {
    allowedAuthorityTypes: [AUTHORITY_TYPES.UNIFORM_TITLE],
    requiresContributorType: false,
  },
};

// Get allowed authority types for a field
export const getAllowedAuthorityTypes = (fieldPath) => {
  return FIELD_AUTHORITY_MAPPING[fieldPath] || [AUTHORITY_TYPES.ALL];
};

// Check if authority type is allowed for field
export const isAuthorityTypeAllowed = (fieldPath, authorityType) => {
  const allowedTypes = getAllowedAuthorityTypes(fieldPath);

  // Check both the original type and mapped types
  const isAllowed = allowedTypes.includes(authorityType) ||
                   allowedTypes.includes(AUTHORITY_TYPES.ALL);

  return isAllowed;
};
